import React from 'react';
import TalentAcademiesContent from '../function-components/TalentAcademiesContent'

function Awards() {
  return (
      <>
        <TalentAcademiesContent />
      </>
  )
}

export default Awards;